import { render } from "./FloorAreaMenu.vue?vue&type=template&id=5340c547"
import script from "./FloorAreaMenu.vue?vue&type=script&lang=js"
export * from "./FloorAreaMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__